<template>
  <div class="maintenance-subtitle">
    <span>{{ $t('alert-info-text') }}</span>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
.maintenance-subtitle {
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  font-weight: 400;
  color: $bodyText;
  max-width: 396px;
  margin-top: 1rem;
}
</style>
